import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-canal-interno',
    templateUrl: './canal-interno.component.html',
    styleUrls: ['./canal-interno.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CanalInternoComponent {


  

}
